import { useBreakpointV2 } from "@tm/ui-widgets";
import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";

const DesktopRating = dynamic<FeedbackComponentProps>(
  //@ts-ignore
  () => import("MMT-UI/userRatings/desktopRating"),
  { ssr: false }
);

const PwaRating = dynamic<FeedbackComponentProps>(
  //@ts-ignore
  () => import("MMT-UI/userRatings/pwaRating"),
  { ssr: false }
);

type Feedback = {
  description: string;
  descriptionId: string;
  id: string;
  rating: number;
  title: string;
  titleId: string;
};

type FeedbackComponentProps = {
  onFeedbackClose: (feedback: Feedback, errorObj: any) => void;
  onBeforeSubmitFeedback: (feedback: Feedback, errorObj: any) => void;
  bookingId: string | null;
  bookingDetails?: any;
};

type TmNPSFeedbackProp = {
  onFeedbackCloseAnalytics: () => void;
  onSubmitFeedbackAnalytics: (feedbackData: Feedback) => void;
  bookingId: string | null;
};

const TmNPSFeedback: React.FC<TmNPSFeedbackProp> = ({
  onFeedbackCloseAnalytics,
  onSubmitFeedbackAnalytics,
  bookingId,
}) => {
  const device = useBreakpointV2();
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);

  useEffect(() => {
    const originalStyle = document.body.style.overflow;
    if (showFeedbackForm) {
      document.body.style.setProperty("overflow", "hidden", "important");
    }
    return () => {
      document.body.style.overflow = originalStyle || "";
    };
  }, [showFeedbackForm]);

  useEffect(() => {
    if (bookingId !== null) {
      setShowFeedbackForm(true);

      const cookieName = `npsFeedback_${bookingId}`;
      const existingCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${cookieName}=`));

      if (existingCookie) {
        setShowFeedbackForm(false);
      }
    }
  }, [bookingId]);

  const npsCookieMaker = () => {
    const cookieName = `npsFeedback_${bookingId}`;
    const existingCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${cookieName}=`));

    if (!existingCookie) {
      document.cookie = `${cookieName}=true; expires=${new Date(
        Date.now() + 7 * 24 * 60 * 60 * 1000
      ).toUTCString()}; path=/`;

      setShowFeedbackForm(true);
    }
  };

  const onFeedbackClose = () => {
    onFeedbackCloseAnalytics();
    npsCookieMaker();
    setShowFeedbackForm(false);
  };

  const onSubmitFeedback = (feedbackData: any) => {
    onSubmitFeedbackAnalytics(feedbackData);
    npsCookieMaker();
    setShowFeedbackForm(false);
  };

  const FeedbackComponent: React.ComponentType<FeedbackComponentProps> =
    device === "lg" ? DesktopRating : PwaRating;

  const feedbackSource = device === "lg" ? "DWEB" : "PWA";

  return (
    <>
      {showFeedbackForm && (
        <FeedbackComponent
          onFeedbackClose={onFeedbackClose}
          onBeforeSubmitFeedback={onSubmitFeedback}
          bookingId={bookingId}
          bookingDetails={{
            bookingId: bookingId,
            bookingStatus: "success",
            source: feedbackSource,
            // lob: "Forex",
            // category: "Forex_PC_Buy",
            org: "MMT",
          }}
        />
      )}
    </>
  );
};

export default TmNPSFeedback;
